export default __webpack_public_path__ + "static/media/arrow-left.inline.c4776e28.svg";